import React, { type ReactNode, type ComponentType } from 'react';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import AppStyle from '@atlassian/jira-common-components-app-style/src/index.tsx';
import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import type { ProjectPagesTheme } from './view/types.tsx';
import View from './view/view.tsx';

export type Props = {
	isAdmin: boolean;
	isSiteAdmin: boolean;
	baseUrl: string;
	locale: Locale;
	cloudId: string;
	accountId: string | undefined | null;
	projectKey: string;
	projectId: string | number;
	projectName: string;
	projectType: string;
	environment: string | undefined | null;
	theme?: ProjectPagesTheme;
	breadcrumbs: ReactNode;
	PerformanceTracking?: ComponentType<{
		loading: boolean;
	}>;
	parentProduct?: string;
};

export default function ProjectPagesApp(props: Props) {
	return (
		<AppBase>
			<AppStyle>
				<View {...props} />
			</AppStyle>
		</AppBase>
	);
}
